import { createTheme } from '@atom-web/core'

import buttons from './buttons'
import * as colors from './colors'
import inputs from './inputs'

const theme = createTheme({
	type: 'light',
	theme: {
		colors: {
			...colors,
			...buttons,
			...inputs,

			checkbox: '$red04',
			'checkbox-shadow': '$red04',
			'checkbox-hover-shadow': '$red04',
			'checkbox-focus-border': '$red04',
			'checkbox-focus-shadow': '$red04',

			'divider-bg': '$grey06',

			'dialog-panel-bg': '$white',
			'dialog-panel-shadow-light': 'hsl(206 22% 7% / 35%)',
			'dialog-panel-shadow-dark': 'hsl(206 22% 7% / 20%)',
			'dialog-close-icon': '$black',

			radio: '$black',
			'radio-indicator-bg': '$purple10',
			'radio-shadow': '$grey08',
			'radio-hover-shadow': '$grey08',
			'radio-focus-border': '$red08',
			'radio-focus-shadow': '$purple09',

			'skeleton-bg': '$grey02',
			'skeleton-after-bg': '$grey03',

			'select-bg': '$white',
			'select-shadow': '$grey08',
			select: '$black',
			'select-focus-shadow': '$purple09',

			'accordion-item-border': '$custom02',
			'accordion-tigger': '$white',
			'accordion-tigger-hover-bg': '$black',
			'accordion-tigger-focus-shadow': '$grey08',
			'accordion-tigger-icon': '$grey09',

			'modal-panel-bg': '$white',
			'modal-panel-shadow-light': 'hsl(206 22% 7% / 35%)',
			'modal-panel-shadow-dark': 'hsl(206 22% 7% / 20%)',

			'nav-link': '#333',
			'nav-link-hover': '#00774F',

			'collapsible-icon-button': 'hsl(250, 43.0%, 48.0%)',
			'collapsible-shadow': 'hsla(0, 0%, 0%, 0.141)',
			'collapsible-link': '#333',
			'collapsible-link-hover': '#00774F',

			'drawer-overlay': 'hsla(0, 0%, 0%, 0.439)',
		},
		space: {
			1: '4px',
			2: '8px',
			3: '12px',
			4: '16px',
			5: '20px',
			6: '24px',
			7: '32px',
			8: '40px',
			9: '48px',
		},
		sizes: {
			1: '4px',
			2: '8px',
			3: '16px',
			4: '20px',
			5: '24px',
			6: '40px',
			7: '48px',
			8: '64px',
			9: '80px',
		},
		radii: {
			1: '4px',
			2: '6px',
			3: '8px',
			4: '12px',
			5: '16px',
			round: '50%',
			pill: '9999px',
		},
		zIndices: {
			1: '100',
			2: '200',
			3: '300',
			4: '400',
			max: '999',
		},
		fontSizes: {
			0: '10px',
			1: '12px',
			2: '14px',
			3: '16px',
			4: '18px',
			5: '20px',
			6: '24px',
			7: '28px',
			8: '36px',
			9: '60px',
		},
		lineHeights: {
			1: '18px',
			2: '20px',
			3: '24px',
			4: '28px',
			5: '36px',
			6: '44px',
			7: '56px',
			8: '60px',
			9: '80px',
		},
		fonts: {
			system: 'system-ui',
			sans: 'Source Sans Pro',
			input: '$sans',
			text: '$sans',
			select: '$sans',
		},
		fontWeights: {
			normal: 400,
			bold: 600,
			bolder: 700,
		},
	},
	utils: {},
	media: {
		sm: '(min-width: 640px)',
		lg: '(min-width: 768px)',
		xl: '(min-width: 1024px)',
		xxl: '(min-width: 1280px)',
		motion: '(prefers-reduced-motion)',
		hover: '(any-hover: hover)',
		dark: '(prefers-color-scheme: dark)',
		light: '(prefers-color-scheme: light)',
	},
})

// export type ThemeConfig = typeof theme
// export type CSS = CoreCSS<typeof theme.config>

export default theme
